import { Component, OnInit } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { ActivatedRoute } from '@angular/router';
import { Product } from 'src/app/models/product';
import { DevicesService } from 'src/app/_services/devices.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  diviceXs: boolean;
  diviceSm: boolean;

  products: Product[];

  constructor(public mediaObserver: MediaObserver, private devicesService: DevicesService, private route: ActivatedRoute) {
    console.log('llamado ctr');
    
   }

  ngOnInit(): void {

    this.route.data.subscribe((data) => {
      this.products = data['products'];
      console.log("this.products", this.products);
    });

    this.devicesService.dievice$.subscribe(res => {
      console.log("device",res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });
  }

}
